import { Box, useTheme } from '@mui/material';

import { Loader } from 'shared/components/Loader';

import { Wrapper } from './components/Wrapper';
import { useMainLoading } from './hooks';

import type { FC } from 'react';

export const MainLoader: FC = () => {
  const theme = useTheme();
  const isLoading = useMainLoading();

  if (!isLoading) {
    return null;
  }

  return (
    <Wrapper>
      <Box
        sx={{
          padding: 5,
          borderRadius: '16px',
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Loader />
      </Box>
    </Wrapper>
  );
};
